import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompaniesComponent {
  public readonly companies = [
    'flying-tiger',
    'o2',
    'tesco',
    'telenor',
    'telekom',
    'orange',
    'A1',
    'dm',
    'coop',
    'penny-market',
    'nay',
    'intersport',
    'mango',
    'max-mara',
    'cbre',
    'tag-heuer',
    'alltoys',
    'terno',
  ];
}
